import{connect}from'react-redux';import{getSubTotal}from'@shopgate/pwa-common-commerce/cart/selectors';/**
 * Maps the contents of the state to the component props.
 * @param {Object} state The current application state.
 * @return {Object} The extended component props.
 */var mapStateToProps=function mapStateToProps(state){return{amount:getSubTotal(state)};};export default connect(mapStateToProps);